import transferSuccessArt from "../assets/images/transferSuccessArt.svg";
import shortcutsbg from "../assets/images/shortcutsbg.jpg";
import bulletsbg from "../assets/images/bulletsbg.svg";

export default {
  transferSuccessArt,
  shortcutsbg,
  bulletsbg,
};
